export function useTheme({ color }) {
  return {
    color,
  };
}
